module.exports = __webpack_public_path__ + "img/minilogo-positivo.68b2d061.svg";